module.exports = __webpack_public_path__ + "static/media/nusclearlabjiaming.555b1430.jpeg";